<template>
  <div class="q-pa-md bg-grey-3 rounded-borders">
    <q-expansion-item
      expan-separator
      icon="fas fa-city"
      :label="sampleDetail.name"
      caption="样本详情"
    >
      <div class="q-mb-lg">
        样本名称：{{ sampleDetail.name }} <br />
        样本 ID： {{ sampleDetail.sample_id }} <br />
        注册地址： {{ sampleDetail.dom ? sampleDetail.dom : "缺失" }} <br />
        经营地址: {{ sampleDetail.addr ? sampleDetail.addr : "缺失" }}<br />
        联系方式：{{ sampleDetail.tel ? sampleDetail.tel : "缺失" }}<br />
        备注信息:
        {{
          sampleDetail.memver_note ? sampleNotes.memver_note : "暂无备注信息"
        }}
      </div>
      <div class="row justify-between">
        <!-- <show-image-button v-if="sample" :hasImage="hasImage" :sample="sample" /> -->
        <!-- <q-btn v-if="!ifHidden" rounded   >
              添加备注信息
            </q-btn> -->
      </div>
    </q-expansion-item>
  </div>
  <!-- $route.params.sample_id  -->
</template>

<script>
export default {
  props: {
    sampleDetail: {
      type: Object,
      default: {},
    },
    ifHidden: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
<style>
</style>